/** `CostPreview`'s own catalogue. */

import { defineCatalogue } from '../../../i18n';

export const costPreviewCatalogue = defineCatalogue(
  { perDay: '{credits} créditos/dia', unpriced: 'sem preço' },
  { perDay: '{credits} credits/day', unpriced: 'no price' },
);

export const cpt = costPreviewCatalogue.t;
